frontApp.productGallery = {
  name: 'productSlider',
  description: 'product slider',
  dr: null,
  init() {
    const galleries = document.querySelectorAll('.js-product-gallery');

    if (!galleries.length) {
      return;
    }

    galleries.forEach((gallery) => {
      this.initGallery(gallery);
    });
  },
  initGallery(gallery) {
    const main = gallery.querySelector('.js-product-gallery-main');

    // Create list of src for fancybox
    const fancyboxItems = [];
    const imagesZoom = main.querySelectorAll('[data-zoom]');
    if (imagesZoom.length && !gallery.classList.contains('js-zoom-off')) {
      imagesZoom.forEach((img) => {
        fancyboxItems.push({
          src: img.getAttribute('data-zoom'),
        });
      });
    }

    // Create a template of thumbs slider
    const thumbs = this.createThumbs();

    main.querySelectorAll('img').forEach((img, idx) => {
      // Create a thumb for each slide of the main slider
      // and add to the thumbs slider template
      let thumbSrc = img.getAttribute('src');
      const dataThumb = img.getAttribute('data-thumb');
      if (dataThumb) {
        thumbSrc = dataThumb;
      }
      const thumbItemTpl = this.createThumbItem(thumbSrc, idx);

      thumbs.querySelector('.swiper-wrapper').append(thumbItemTpl);
    });

    // Add thumbs slider in DOM
    main.parentElement.after(thumbs);

    // Create instance of thumbs slider
    const thumbsInstance = new Swiper(thumbs.querySelector('.swiper'), {
      direction: 'vertical',
      spaceBetween: 10,
      slidesPerView: 'auto',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      shortSwipes: false,
      longSwipesMs: 50,
      longSwipesRatio: 0.05,
      watchOverflow: true,
      navigation: {
        prevEl: thumbs.querySelector('.js-product-gallery-thumbs-prev'),
        nextEl: thumbs.querySelector('.js-product-gallery-thumbs-next'),
      },
      breakpoints: {
        992: {
          spaceBetween: 20,
        },
      },
    });

    // Create instance of main slider
    const slidesLength = main.querySelectorAll('.swiper-slide').length;
    const mainInstance = new Swiper(main.querySelector('.swiper'), {
      init: false,
      loop: slidesLength > 1,
      loopedSlides: 1,
      spaceBetween: 18,
      slidesPerView: 'auto',
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      centeredSlides: true,
      thumbs: {
        swiper: thumbsInstance,
      },
      pagination: {
        type: 'fraction',
        el: '.js-product-gallery-main-pagination',
      },
      navigation: false,
      breakpoints: {
        992: {
          slidesPerView: 1,
          centeredSlides: false,
          allowTouchMove: false,
          spaceBetween: 30,
        },
      },
    });

    mainInstance.on('init', (slider) => {
      gallery.classList.add('is-loaded');

      const curSlide = slider.slides[slider.activeIndex];

      if (
        !gallery.classList.contains('js-zoom-off')
        && !('ontouchstart' in document.documentElement)
        && curSlide
      ) {
        if (this.dr) this.dr.destroy();

        // Magnifier (on desktop)
        this.imageZoom(curSlide.querySelector('[data-zoom]'));
      }
    });

    mainInstance.on('slideChange', (slider) => {
      const curSlide = slider.slides[slider.activeIndex];

      if (
        window.matchMedia('(min-width: 992px)').matches
        && !gallery.classList.contains('js-zoom-off')
        && !('ontouchstart' in document.documentElement)
        && curSlide
      ) {
        if (this.dr) this.dr.destroy();

        // Magnifier (on desktop)
        this.imageZoom(curSlide.querySelector('[data-zoom]'));
      }
    });

    // Fancybox zoom (on mobile)
    const fancyboxOptions = {
      startIndex: 0,
      mainClass: 'image-zoom-theme hide-thumbs',
      Toolbar: {
        display: [
          'counter',
          'close',
        ],
      },
      on: {
        shouldClose: (fancybox) => {
          const { page } = fancybox.Carousel;
          if (mainInstance.params.loop) {
            mainInstance.slideToLoop(page, 0);
          } else {
            mainInstance.slideTo(page, 0);
          }
        },
      },
    };

    document.querySelector('.js-product-gallery-main-zoom').addEventListener('click', () => {
      fancyboxOptions.startIndex = mainInstance.realIndex;
      Fancybox.show(fancyboxItems, fancyboxOptions);
    });

    if (!gallery.classList.contains('js-zoom-off')) {
      const mainSlider = main.querySelectorAll('.swiper-slide');
      mainSlider.forEach((slide) => {
        slide.addEventListener('click', (event) => {
          const { target } = event;
          if (window.matchMedia('(max-width: 991px)').matches) {
            fancyboxOptions.startIndex = Number(target.getAttribute('data-swiper-slide-index'));
            Fancybox.show(fancyboxItems, fancyboxOptions);
          }
        });
      });
    }

    // Init main slider
    mainInstance.init();
  },
  createThumbs() {
    const tpl = document.createElement('div');

    tpl.classList.add('product-gallery__thumbs');
    tpl.classList.add('js-product-gallery-thumbs');

    tpl.innerHTML = `<div class="product-gallery-thumbs">
  <button class="product-gallery-thumbs__button product-gallery-thumbs__button--prev js-product-gallery-thumbs-prev"><svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.499 1.678a2 2 0 1 1 3.002 2.644l-3.002-2.644Zm3.036 32.707a2 2 0 1 1-3.07 2.563l3.07-2.563ZM12 18.898l-1.535 1.282a2 2 0 0 1 .034-2.604L12 18.898ZM27.501 4.322l-14 15.898-3.002-2.644 14-15.898 3.002 2.644ZM13.535 17.616l14 16.769-3.07 2.563-14-16.768 3.07-2.564Z" fill="currentColor"/></svg></button>
  <div class="swiper"><div class="swiper-wrapper"></div></div>
  <button class="product-gallery-thumbs__button product-gallery-thumbs__button--next js-product-gallery-thumbs-next"><svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.501 1.678a2 2 0 1 0-3.002 2.644l3.002-2.644Zm-3.036 32.707a2 2 0 1 0 3.07 2.563l-3.07-2.563ZM26 18.898l1.535 1.282a2 2 0 0 0-.034-2.604L26 18.898ZM10.499 4.322l14 15.898 3.002-2.644-14-15.898-3.002 2.644Zm13.966 13.294-14 16.769 3.07 2.563 14-16.768-3.07-2.564Z" fill="currentColor"/></svg></button>
</div>`;

    return tpl;
  },
  createThumbItem(src, idx) {
    const tpl = document.createElement('div');

    tpl.classList.add('swiper-slide');
    tpl.classList.add('product-gallery-thumbs__item');

    tpl.innerHTML = `<div class="swiper-slide product-gallery-thumbs__el"><img src="${src}" alt="image thumb ${idx + 1}" /></div>`;

    return tpl;
  },
  imageZoom(el) {
    // Инициировать скрипт с лупой нужно каждый раз для активоного слайда
    // на событие "changeSlide"
    // удаляя предыдущий экземпляр.
    // Это необходимо, потому что слайдер создает динамически дубликаты слайдов.
    const zoomFactor = 1.5;
    const dr = new Drift(el, {
      namespace: 'zoom-ruler',
      sourceAttribute: 'data-zoom',
      inlinePane: true,
      containInline: true,
      zoomFactor,
      injectBaseStyles: false,
      onShow() {
        const containerWidth = Math.round(dr.triggerEl.parentElement.offsetWidth);
        const paneWidth = Math.round(containerWidth + containerWidth * zoomFactor - containerWidth);
        const l = Math.round((containerWidth - paneWidth) / 2);
        const element = dr.zoomPane.el;
        element.style.width = `${paneWidth}px`;
        element.style.transform = `translateX(${l}px)`;
      },
    });
    this.dr = dr;
  },
};
